import * as React from 'react';
import { Edit, useNotify, useAuthState, Loading } from 'react-admin';
import { JobForm, JobTitle } from '../jobs/commons';
import JobShow from '../jobs/JobShow';
import { preventSubmitOnSubmit } from './utils';

const JobPublicEdit = () => {
    const notify = useNotify();
    const { isLoading, authenticated } = useAuthState();
    if (isLoading) {
        return <Loading />;
    }
    return (
        <Edit title={<JobTitle />} mutationMode="pessimistic" disableAuthentication>
            <>
                <JobForm onSubmit={preventSubmitOnSubmit(authenticated, notify)}/>
                <JobShow />
            </>
        </Edit >
    )
};

export default JobPublicEdit;
